import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AssistantWidgetService {
  readonly isOpen = signal(false);

  open(): void {
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
  }

  toggle(): void {
    this.isOpen.update((open) => !open);
  }
}
